import styled from 'styled-components';

export const SongPresentationContainer = styled.div`
  display: flex;
`;

/* Left Container */

export const ProjectDescriptionContainer = styled.div`
  flex: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: 1px solid #555555;
  padding-top: 55px;

  p {
    padding-left: 56px;
    padding-right: 40px;
  }
`;

export const ProjectDescriptionText = styled.p`
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  color: #f2f2f2;
  max-width: 500px;
  max-height: 460px;
  overflow-y: auto;
`;

export const ActionsButtonContainer = styled.div`
  display: flex;
  max-height: 72px;
  border-top: 1px solid #555555;
  width: 100%;

  div {
    border-right: 1px solid #555555;
  }
  button:last-child {
    border: none;
  }
`;

export const ActionButton = styled.button`
  position: relative;
  min-height: 72px;
  width: 100%;
  border: none;
  background-color: transparent;
  &:hover {
    cursor: pointer;
  }
`;

export const PlayButton = styled.div`
  position: relative;
  min-height: 72px;
  width: 100%;
  border: none;
  background-color: transparent;
  &:hover {
    cursor: pointer;
  }
`;

type ProgressBarProps = {
  audioProgress: number;
  isPlaying: boolean;
};

export const ProgressBar = styled.div<ProgressBarProps>`
  height: 100%;
  width: ${(props) => props.audioProgress}%;
  background-color: #555555;
  transition: ${(props) =>
    props.isPlaying === false ? 'none' : 'width 0.2s linear'};
`;

export const ActionLogo = styled.img`
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CommasLogoStyled = styled.img`
  z-index: -1;
  position: absolute;
  height: 44px;
  left: 32px;
  top: 55px;
`;

/* Right Container */

export const SongAssetsContainer = styled.div`
  flex: 50%;
  border-right: 1px solid #555555;
  border-left: 1px solid #555555;
  padding-top: 40px;
`;

export const SongAssetListContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SongAssetListCenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-right: 30px;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
`;
export const FromStyled = styled.div`
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9c9c9c;
  padding-bottom: 5px;
`;
export const PriceStyled = styled.div`
  width: 84px;
  font-size: 24px;
  line-height: 32px;
  text-align: right;
  color: #ffffff;
  padding-left: 8px;
`;

export const AlbumCoverGrid = styled.div`
  display: grid;
  grid-template-columns: auto max-content auto;
  grid-template-rows: auto max-content auto;
  border-top: 1px solid #555555;
  margin: 32px -1px 0 -1px;
`;

export const GridItems = styled.div`
  display: flex;
  min-height: 30px;
  border-bottom: 1px solid #555555;
  border-right: 1px solid #555555;
`;

export const GridImages = styled.img`
  max-width: 308px;
  width: 100%;
  object-fit: cover;
  display: block;
`;

export const ArtistName = styled.div`
  font-family: 'MabryPro';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.1em;
  color: #9c9c9c;
  padding-left: 30px;
`;

export const SongName = styled.div`
  font-family: 'Recife-Display';
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 58px;
  color: #f6f8fe;
  padding-left: 30px;
  margin: 20px 0px;
`;

export const GetSampleButton = styled.button`
  font-family: 'MabryPro';
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #ea6343;
  color: #fff;
  min-height: 72px;
  width: 100%;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;
